import FileSaver from "file-saver";

export const useFileDownload: () => {
    dowloadFile: (base64: string, contentType: string, fileName: string, sliceSize?: number, options?: FileSaver.FileSaverOptions) => void;
} = () => {

    /**
     * Converte una string base64 in un Blob
     * @param base64 
     * @param contentType 
     * @param sliceSize 
     * @returns 
     */
    const base64ToBlob = (
        base64: string,
        contentType: string = "",
        sliceSize: number = 2048
    ): Blob => {
        const byteCharacters = atob(base64);
        const byteArrays = [];
        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    /**
     * Generate a file by the base64 string and other parameters
     * @param {string} base64
     * @param contentType 
     * @param fileName 
     * @param sliceSize 
     * @param options 
     */
    const dowloadFile = (base64: string, contentType: string, fileName: string, sliceSize?: number, options?: FileSaver.FileSaverOptions) => {
        const blob = base64ToBlob(base64, contentType, sliceSize);

        FileSaver(blob, fileName, options);
    }

    return { dowloadFile };
}